import { privateAxiosIntance } from "../../Config/axios";
import { API_URLS } from "../../Config/urls";



export const getPolicyPrivacyFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.get(API_URLS.policy_privarcy, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const postPolicyPrivacyFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.post(API_URLS.policy_privarcy, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const getReturnPolicyPrivacyFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.get(API_URLS.return_policy, {
            params: reqBody,
        });
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};

export const postReturnPolicyPrivacyFn = (reqBody) => {
    try {
        const response = privateAxiosIntance.post(API_URLS.return_policy, reqBody);
        return response;
    } catch ({ error }) {
        throw new Error(error.message);
    }
};